<entry-confirm-modal-tag>
   <style>
    .modal__content_inner {
      max-height: 80vh;
      overflow-y: auto;
    }
    .wp60 {
      width: 60%;
    }
  </style>

  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h3 class="modal_heading margin-spacing-3_bottom">
          エントリー
        </h3>

        <div class="modal-body">
          
        </div>

        <p class="modal_lead">
          こちらの公募案件にエントリーします
        </p>
        <div class="wrap_button margin-spacing-2_top">
          <div
            class="button button-secondary-large button-border margin-spacing-1_right"
            type="button"
            value="キャンセル"
            onclick="{ props.onClose }"
          >
            キャンセル
          </div>
          <div
            class="button button-secondary-large"
            type="button"
            value="エントリーする"
            onclick="{ props.onSubmit }"
          >
            エントリーする
          </div>
        </div>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>

  <script>
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      }
    };
  </script>

</entry-confirm-modal-tag>
